module.exports = __webpack_public_path__ + "static/media/2_en.4005709a.png";